export function getAllRequiredFormsAnswered({ requiredForms = [], formAnswers } = {}) {
  return requiredForms.every((requiredForm) => formAnswers.hasOwnProperty(requiredForm));
}
